import { render } from "./ActionSelector.vue?vue&type=template&id=aad3985c"
import script from "./ActionSelector.vue?vue&type=script&lang=js"
export * from "./ActionSelector.vue?vue&type=script&lang=js"

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ActionSelector.vue"]])

export default __exports__